import { ListeTable } from '@mairistem/liste';
import _ from 'lodash';
import React, { type ReactNode } from 'react';

import { RegieContext } from '@/contexts';
import type { FactureImpayeeListeItemType, FactureType } from '@/types';

import { formatFacturesToImpayeeListeItem } from '@/utils/facture';
import FacturesImpayeesListeTableHeader from './FacturesImpayeesListeTableHeader';
import FacturesImpayeesListeTableRow from './FacturesImpayeesListeTableRow';

type FacturesImpayeesListeProps = {
  items: FactureType[];
  active?: boolean;
  total: number;
  loading: boolean;
  setPage: (page: number) => void;
};

const FacturesImpayeesListe = (props: FacturesImpayeesListeProps) => {
  const { items, active, total, setPage, loading } = props;

  const { regies, selectedRegie } = React.useContext(RegieContext);

  const regie = React.useMemo(
    () => _.find(regies, { identifiant: selectedRegie }),
    [selectedRegie, regies],
  );

  const formatedFactures = React.useMemo<FactureImpayeeListeItemType[]>(
    () => formatFacturesToImpayeeListeItem(items, regie),
    [items, regie],
  );

  const handleLoad = React.useCallback(
    ({ page }) => {
      setPage(page);
    },
    [setPage],
  );

  const renderRow = (item, invalidate, rowProps) => (
    <FacturesImpayeesListeTableRow item={item} rowProps={rowProps} />
  );

  return (
    <div
      // 306 pile poil 6 lignes
      style={{ height: 306 }}
    >
      <ListeTable
        count={_.isEmpty(formatedFactures) || !active ? 0 : total}
        {...(active
          ? {
              items: formatedFactures,
              onLoad: handleLoad,
              loading,
              perPage: 15,
            }
          : {
              noResultsIcon: '',
              noResultsMessage: "Aucune facture n'est éligible au transfert des impayés",
            })}
      >
        <ListeTable.Header>
          <FacturesImpayeesListeTableHeader />
        </ListeTable.Header>
        {renderRow as unknown as ReactNode}
      </ListeTable>
    </div>
  );
};

export default FacturesImpayeesListe;
